import { LitElement, svg } from "lit";
import { defineComponent } from "../configuration/utils.js";
export class PlaceholderImage extends LitElement {
    render() {
        return svg `
    <svg xmlns="http://www.w3.org/2000/svg" width="200" height="112" fill="none" aria-hidden="true">
      <g clip-path="url(#atlas-gn-placeholder-filter-a)">
        <path fill="#F3F3F3" d="m121.998-31 86.603 50-150 259.808-86.603-50z"/>
        <path fill="#E6E6E6" d="m207.6-31 86.602 50-150 259.809-86.602-50z"/>
      </g>
      <rect width="199" height="71" x=".5" y="32.5" stroke="#DADADA" rx="11.5"/>
      <g filter="url(#atlas-gn-placeholder-filter-b)">
        <rect width="72" height="72" x="24" y="8" fill="#D3222A" rx="12" shape-rendering="crispEdges"/>
        <mask id="atlas-gn-placeholder-mask" width="48" height="48" x="36" y="20" maskUnits="userSpaceOnUse" style="mask-type:alpha">
          <path fill="#D9D9D9" d="M36 20h48v48H36z"/>
        </mask>
        <g mask="url(#atlas-gn-placeholder-mask)">
          <path fill="#fff" d="M48.77 62a2.67 2.67 0 0 1-1.962-.808A2.67 2.67 0 0 1 46 59.23V28.769c0-.768.27-1.422.808-1.96A2.67 2.67 0 0 1 48.77 26h15.57c.389 0 .752.077 1.09.23.337.155.639.352.906.593l6.842 6.842c.241.267.438.57.592.907.154.337.231.7.231 1.09V59.23a2.67 2.67 0 0 1-.808 1.96A2.67 2.67 0 0 1 71.23 62H48.769Zm15.934-28.162v-6.3H48.769c-.307 0-.59.129-.846.385-.256.257-.385.539-.385.846v30.462c0 .307.129.59.385.846s.538.385.846.385h22.462c.308 0 .59-.129.846-.385s.385-.538.385-.846V35.223h-6.374a1.33 1.33 0 0 1-.972-.412 1.33 1.33 0 0 1-.412-.973Z"/>
        </g>
      </g>
      <defs>
        <clipPath id="atlas-gn-placeholder-filter-a">
          <rect width="200" height="72" y="32" fill="#fff" rx="12"/>
        </clipPath>
        <filter id="atlas-gn-placeholder-filter-b" width="112" height="112" x="16" y="0" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
          <feOffset dx="12" dy="12"/>
          <feGaussianBlur stdDeviation="10"/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_8962_3582"/>
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_8962_3582" result="shape"/>
        </filter>
      </defs>
    </svg>
  `;
    }
}
export const PLACEHOLDER_IMAGE_TAG = "atlas-gn-placeholder-image";
defineComponent(PLACEHOLDER_IMAGE_TAG, PlaceholderImage);
